import { useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { StyledContainer, InfoBlock, InfoCard, PasswordCard } from "./Profile.styles";
import { PasswordChange } from "./PasswordChange";
import { useAppDispatch } from "../../hooks/StoreHooks";
import { useProfileData } from "../../store/selectors/profileSelector";
import { fetchProfileThunk } from "../../store/thunk/profileThunk";
import { useTranslation } from "react-i18next";

export function ProfilePage() {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const profile = useProfileData();

    useEffect(() => {
        dispatch(fetchProfileThunk());
    }, [dispatch]);
    if (!profile) return null;

    return (
        <StyledContainer>
            <Typography variant="h4" gutterBottom>
                Profile
            </Typography>

            <InfoCard>
                <InfoBlock>
                    <Typography variant="subtitle2">{t("authentication.register.firstName")}</Typography>
                    <Typography variant="body1">{profile.firstName}</Typography>
                </InfoBlock>

                <InfoBlock>
                    <Typography variant="subtitle2">{t("authentication.register.lastName")}</Typography>
                    <Typography variant="body1">{profile.lastName}</Typography>
                </InfoBlock>

                <InfoBlock>
                    <Typography variant="subtitle2">{t("authentication.register.email")}</Typography>
                    <Typography variant="body1">{profile.email}</Typography>
                </InfoBlock>
            </InfoCard>

            <Box sx={{ mt: 4 }}>
                <Typography variant="h6" gutterBottom>
                    {t("profilePage.changePassword")}
                </Typography>
                <PasswordCard>
                <PasswordChange userId={profile.id} />
                </PasswordCard>
            </Box>
        </StyledContainer>
    );
}
